// Layout general del sistema

import React, { useEffect, useState } from 'react';
import NavMenu from './NavMenu';
import Login from './pages/Login';
import Home from './pages/Home';
import About from './pages/About';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Contracts from './pages/Contracts';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Payroll from './pages/Payroll';
import SchedulesShiftAssignment from './pages/SchedulesShiftAssignment';
import SchedulesRegisterAttendance from './pages/SchedulesRegisterAttendance';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Sites from './pages/Sites';
import TopBar from './components/TopBar';
import Footer from './Footer';
import { useMediaQuery, Drawer } from '@mui/material';
import Quotations from './pages/Quotations';
import { useUser } from './UserContext';
import { usePage } from './PageContext';

function App() {
  const { page, setPage } = usePage();
  const { user, setUser, isMobile } = useUser();
  const isLoggedIn = !!user;
  const isPrivatePage = isLoggedIn && page !== 'login';
  const showNavMenu = user && !isMobile;
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigate = (p) => {
    setPage(p);
    if (isMobile) {
      setMenuOpen(false);
    }
  }

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    setPage('login');
  };

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        console.error('Error parsing savedUser:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('jwt');
      }
    }
  }, []);


  const isPublicPage = ['home', 'login', 'about', 'contact'].includes(page);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <div
      className="App"
      style={{
        display: 'flex',
        minHeight: '100vh'
      }}>

      {/* NavMenu privado */}
      {showNavMenu && (
        <NavMenu onNavigate={handleNavigate} />
      )}
      {isMobile && user && (
        <button
          onClick={toggleMenu}
          style={{
            position: 'fixed',
            top: 10,
            left: 10,
            zIndex: 9999,
            padding: 10,
            background: '#144272',
            color: 'white',
            border: 'none',
            borderRadius: 4,
          }}
        >
          Menú
        </button>
      )}

      {isMobile && (
        <Drawer
          anchor="left"
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
        >
          <div style={{ width: 220 }}>
            <NavMenu onNavigate={handleNavigate} />
          </div>
        </Drawer>
      )}

      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>

        {/* TopBar unico  */}

        <TopBar showNavMenu={showNavMenu}
          user={user}
          isLoggedIn={isLoggedIn}
          onNavigate={handleNavigate}
          onLogout={handleLogout}
          setOpen={setMenuOpen}
        />

        {/* contenido global centrado */}
        <main
          style={{
            flex: 1,
            marginLeft: showNavMenu ? '200px' : '0',
            paddingTop: '90px',
            paddingBottom: '100px',
            paddingRight: '15px',
            paddingLeft: '15px',
            minWidth: 0,
            overflowX: "hidden",
            overflowY: "auto"
          }}
        >
          <div style={{
            width: '100%',
            maxWidth: '1100'
          }}>

            {page === 'home' && <Home />}
            {page === 'about' && <About />}
            {page === 'contact' && <Contact />}
            {page === 'quotations' && <Quotations />}
            {page === 'dashboard' && <Dashboard />}
            {page === 'users' && <Users />}
            {page === 'sites' && <Sites />}
            {page === 'clients' && <Clients />}
            {page === 'contracts' && <Contracts />}
            {page === 'shift-assignment' && <SchedulesShiftAssignment />}
            {page === 'attendance' && <SchedulesRegisterAttendance />}
            {page === 'payroll' && <Payroll />}
            {page === 'finance' && <Finance />}
            {page === 'reports' && <Reports />}
            {page === 'settings' && <Settings />}

            {page === 'login' && <Login onNavigate={handleNavigate} />}

          </div>
        </main>
        <Footer />
      </div>
    </div>

  );
}

export default App;
